/**
 * Functions used by survey questionnaires
 * Any script used in more than one questionnaire should be in here
 */

/**
 * given a component survey toggle it
 */
function toggleSurveyEngineElement(fieldElement, fieldValue, targetId, targetSelector, equalsFieldValue ) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if (targetSelector)
		targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

	var doEquals = true;
	if( equalsFieldValue != undefined )
		doEquals = equalsFieldValue;

    if($(targetId).data("priority-hide") ){
        return;
    }

	if( doEquals ) {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) > -1) {
				$(targetId).show();
			} else {
				$(targetId).hide();
			}
		} else {
			if (fieldElement.value === fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ) {
					$(targetId).hide();
				} else {
					$(targetId).show();
				}
			} else {
				$(targetId).hide();
			}
		}
	} else {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) === -1) {
				$(targetId).show();
			} else {
				$(targetId).hide();
			}
		} else {
			if (fieldElement.value != fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ) {
					$(targetId).hide();
				} else {
					$(targetId).show();
				}
			} else {
				$(targetId).hide();
			}
		}
	}
	addResponderNameToContent();
}

function toggleSurveyEngineElementMatchingOnly(fieldElement, fieldValue, targetId, targetSelector, equalsFieldValue ) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if (targetSelector)
		targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

	var doEquals = true;
	if( equalsFieldValue != undefined )
		doEquals = equalsFieldValue;

    if($(targetId).data("priority-hide") ){
        return;
    }

	if( doEquals ) {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) > -1) {
				$(targetId).show();
			}
		} else {
			if (fieldElement.value === fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ) {
					$(targetId).hide();
				} else {
					$(targetId).show();
				}
			}
		}
	} else {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) === -1) {
				$(targetId).show();
			}
		}
		else {
			if (fieldElement.value != fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ) {
					$(targetId).hide();
				} else {
					$(targetId).show();
				}
			}
		}
	}
	addResponderNameToContent();
}

function toggleSurveyEngineElementTwoElements(fieldElement1, fieldValue1, fieldElement2, fieldValue2, targetId, targetSelector, equalsFieldValue ){
        targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

        if($(targetId).data("priority-hide") ){
            return;
        }

        if (targetSelector)
            targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

        var doEquals = true;
        if( equalsFieldValue != undefined )
            doEquals = equalsFieldValue;

        if( doEquals ) {
            if (fieldElement1.value === fieldValue1 && fieldElement2.value === fieldValue2) {
                $(targetId).show();
            }else{
                $(targetId).hide();
            }
        } else {
            if (fieldElement1.value != fieldValue1 && fieldElement2.value != fieldValue2) {
                $(targetId).show();
            }else{
                $(targetId).hide();
            }
        }
        addResponderNameToContent();
}

function toggleSurveyEngineElementByEitherValue(fieldElement, fieldValue1, fieldValue2, targetId, targetSelector, equalsFieldValue ) {
    targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

    if($(targetId).data("priority-hide") ){
        return;
    }

    if (targetSelector)
        targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

    var doEquals = true;
    if( equalsFieldValue != undefined )
        doEquals = equalsFieldValue;

    if( doEquals ) {
        if (fieldElement.value === fieldValue1 || fieldElement.value === fieldValue2) {
            if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ){
                $(targetId).hide();
            }else{
                $(targetId).show();
            }
        }else
            $(targetId).hide();
    } else {
        if (fieldElement.value != fieldValue1 || fieldElement.value != fieldValue2) {
            if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ){
                $(targetId).hide();
            }else{
                $(targetId).show();
            }
        }else{
            $(targetId).hide();
        }
    }
    addResponderNameToContent();
}

function toggleSurveyEngineElementByManyValue(fieldElement, fieldValue1, fieldValue2, fieldValue3, targetId, targetSelector, equalsFieldValue ) {
    targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

    if($(targetId).data("priority-hide") ){
        return;
    }

    if (targetSelector)
        targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

    var doEquals = true;
    if( equalsFieldValue != undefined )
        doEquals = equalsFieldValue;

    if( doEquals ) {
        if (fieldElement.value === fieldValue1 || fieldElement.value === fieldValue2 || fieldElement.value === fieldValue3) {
            if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ){
                $(targetId).hide();
            }else{
                $(targetId).show();
            }
        }
        else
            $(targetId).hide();
    } else {
        if (fieldElement.value != fieldValue1 || fieldElement.value != fieldValue2 || fieldElement.value === fieldValue3) {
            if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked ){
                $(targetId).hide();
            }else{
                $(targetId).show();
            }
        }else{
            $(targetId).hide();
        }
    }
    addResponderNameToContent();
}

function toggleSurveyEngineElementOff(fieldElement, fieldValue, targetId, targetSelector, equalsFieldValue ) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if($(targetId).data("priority-hide") ){
        return;
    }

	if (targetSelector)
		targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

	var doEquals = true;
	if( equalsFieldValue != undefined )
		doEquals = equalsFieldValue;

	if( doEquals ) {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) > -1)
				$(targetId).hide();
			else
				$(targetId).show();
		}
		else {
			if (fieldElement.value === fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked )
					$(targetId).show();
				else
					$(targetId).hide();
			}
			else
				$(targetId).show();
		}
	}
	else {
		if( fieldValue instanceof Array ) {
			if($.inArray(fieldElement.value, fieldValue) === -1)
				$(targetId).hide();
			else
				$(targetId).show();
		}
		else {
			if (fieldElement.value != fieldValue) {
				if((fieldElement.type === 'checkbox' || fieldElement.type === 'radio') && !fieldElement.checked )
					$(targetId).show();
				else
					$(targetId).hide();
			}
			else
				$(targetId).show();
		}
	}
	addResponderNameToContent();
}

function toggleSurveyEngineElementOffOnly(fieldElement, fieldValue, targetId, targetSelector, equalsFieldValue ) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if($(targetId).data("priority-hide") ){
        return;
    }

    if (targetSelector)
        targetId = targetSelector; // allows the survey engine to pass in the jquery css selector criteria

    var doEquals = true;
    if( equalsFieldValue != undefined )
        doEquals = equalsFieldValue;

    if( doEquals ) {
        if( fieldValue instanceof Array ) {
            if($.inArray(fieldElement.value, fieldValue) > -1)
                $(targetId).hide();
        }
        else {
            if (fieldElement.value === fieldValue) {
                $(targetId).hide();
            }
        }
    }
    else {
        if( fieldValue instanceof Array ) {
            if($.inArray(fieldElement.value, fieldValue) === -1)
                $(targetId).hide();
        }
        else {
            if (fieldElement.value != fieldValue) {
                $(targetId).hide();
            }
        }
    }
    addResponderNameToContent();
}

/**
 * toggle a checked element
 */
function enforceExclusiveCheckbox(fieldElement, exclusiveValue) {
	if (!fieldElement.checked) {
		return;
	}
	var group = $('input[name="' + fieldElement.name + '"]');
	var others = (fieldElement.value === exclusiveValue)
			? group.not(fieldElement)
			: group.filter('[value="' + exclusiveValue + '"]');
	others.filter(':checked').prop('checked', false).each(function () {
		if (typeof this.onclick === 'function') {
			this.onclick(); // re-run the sibling's own toggle so its container hides
		}
	});
}

function toggleSurveyEngineCheckedElementParent(fieldElement, targetId, targetSelector) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if (targetSelector) {
		targetId = targetSelector; // allows the survey engine to pass in the
									// jquery css selector criteria
	}
	if (fieldElement.checked) {
		$(targetId).parent().parent().show();
	} else {
		$(targetId).parent().parent().hide();
	}
}

/**
 * toggle a checked element
 */
function toggleSurveyEngineCheckedElement(fieldElement, targetId, targetSelector) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if (targetSelector) {
		targetId = targetSelector; // allows the survey engine to pass in the
									// jquery css selector criteria
	}

	if($(targetId).data("priority-hide") ){
        return;
    }

	if (fieldElement.checked) {
		$(targetId).show();
	} else {
		$(targetId).hide();
	}
	addResponderNameToContent();
}

function toggleElementByEitherQuestion(element1Id, element2Id, blockContainer) {
	var firstElement = document.getElementById(element1Id);
	var secondElement = document.getElementById(element2Id);
	var container = document.getElementById(blockContainer);
	if (firstElement.checked || secondElement.checked) {
		container.style.display = "block";
	} else {
		container.style.display = "none";
	}
     addResponderNameToContent();
}

function toggleSurveyEngineCheckedElementUsingPrefix(fieldElement, targetIdPrefix) {
	targetId = "#" + targetId.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" ); // jquery wait to find element by id

	if (fieldElement.checked) {
		$(targetId).show();
	} else {
		$(targetId).hide();
	}

	addResponderNameToContent();
}

/*
* Given county field(elementId) and state field(targetId)
* Set state field based on county's state
*/
function toggleState(elementId, targetId){
    var countyState = $('#'+elementId+' :selected').attr('state')
    if(countyState !== 'undefined'){
        $('#'+targetId).val(countyState).change();
    }
}

function assessAge(elementId, target, respId, respFn, respLn){
    var age = new Date($('#'+elementId).val());
    var diff = Date.now() - age.getTime();
    var ageDate = new Date(diff);
    var ret = Math.abs(ageDate.getUTCFullYear()-1970)
    var responderName = findResponderName(respId,false);
    if(ret >= 65 && age !== 'undefined'){
        var mess = $("#over_65").val();
        mess = mess.split("[FNLNS]").join("<oitext data-responder-id='"+respId+"' class='FN'>"+responderName+"</oitext>");
        $('#'+target +"-fieldSet").html(mess);
    }else if(ret < 65 && age != 'undefined'){
        var mess = $("#under_65").val();
        mess = mess.split("[FNLNS]").join("<oitext data-responder-id='"+respId+"' class='FN'>"+responderName+"</oitext>");
        $('#'+target +"-fieldSet").html(mess);
    }
    addResponderNameToContent();

}

function toggleRelationship(elementId, relationshipType,  targetElementId){

}

/*
* Given county field(elementId) and state field(targetId)
* Set fips field based on county's state
*/
function toggleFips(elementId, targetId){
    var countyFips = $('#'+elementId+' :selected').attr('fips')
    if(countyFips !== 'undefined'){
        $('#'+targetId).val(countyFips);
    }
}


function hideSelectedApplicantContainer(element, containerId, testValue) {
	if (element.value == testValue) {
		var container = document.getElementById(containerId);
		var allInputs = container.getElementsByTagName("input");
		for (var i=0; i < allInputs.length; i++) {
			if (allInputs.type = 'checkbox') {
				if (allInputs[i].checked) {
					allInputs[i].click();
				}
			}
		}
	}
}

function processButtonEvent(cmd, targetId, sourceId, value) {
    var appendValue = getAppendedValue(sourceId);
    if(appendValue != ''){
       targetId =  targetId + "-" + appendValue;
    }
    ajax_CopyEvent(cmd, targetId, sourceId, value);
}

function processCheckBox(cmd, targetId, sourceId, value) {
	var element = document.getElementById(sourceId);
	if (element.type == 'checkbox') {
		var cmd =null;
		if (element.checked) {
			cmd = 'GetTarget';
		}
		else {
			cmd = 'RemoveTarget';
		}
		ajax_makeRequest(cmd, targetId, element.id, element.value);
	}

	return false;
}


function addCopy(data, sourceId, targetId){;
    if(targetId.indexOf('-ajax') > 0) {
        targetId = targetId.replace('-ajax', '');
    }

    var target = targetId;
    var indexOf = target.indexOf('[');
    if(indexOf > -1){
        target = target.substring(0, indexOf);
    }

    if(sourceId.indexOf("[") > 0){
        target = target+ '-ajax';
    }
    else {
        target = target+ '-ajax';
    }
    $("#"+target).html(data);
}

function getAppendedValue(value) {
    var returnValue = '';
    if (value.indexOf('-') > 0) {
        var indexOf = value.lastIndexOf('-');
        var length = value.length;

        var indexOfCopy = value.lastIndexOf('_');
        if (indexOfCopy == undefined){
            indexOfCopy = value.lastIndexOf('[');
        }
        if(indexOfCopy > -1){
           length = indexOfCopy;
        }
        returnValue = value.substring(indexOf+1,length);
    }else if(value.indexOf('[') > 0) {
        var indexOf = value.lastIndexOf('[');
        var length = value.length;

        returnValue = value.substring(indexOf,length);
    }
    return returnValue;
}

function getArrayIndex(source){
   var open = source.name.indexOf('[', 0);
   var close = source.name.indexOf(']', 0);
   return source.name.substring(open+1,close);
}

function ajax_loadContainer(containerId, cmd, sourceId){
  ajax_CopyEvent(cmd, containerId, sourceId, null);
}

function ajax_loadContainerWithDependant(containerId, cmd, dependantId){
   var dependantComponent = document.getElementsByName(dependantId);
   if(dependantComponent.length > 0){
       for(var i=0; i<dependantComponent.length; i++){
           if(dependantComponent[i].checked){
               dependantComponent[i].checked = false;
               dependantComponent[i].click();
           }
       }
   }
}

function ajax_makeRequest(cmd, targetId, sourceId, value){
    var surveyForm = $("#"+surveyEngineFormId);
    var target = targetId+"-"+value+'-ajax';
    $("input[name='_eventId']",surveyForm).val("ajaxRequest");
    $.ajax({
       type: 'POST',
       url: surveyForm.attr("action"),
       data: surveyForm.serialize()+"&ajaxSource=true&sourceValue="+value+"&targetId="+targetId+"&sourceId="+sourceId+"&command="+cmd,
       dataType: 'html',
       success: function(data) {
           if(data == null){
             $("#"+target).html('');
           }
           else {
             $("#"+target).html(data);
           }
           applyRules();
       },
       statusCode: {
         404: function() {
           alert('page not found');
         }
       }
     });
 }

 function ajax_CopyEvent(cmd, targetId, sourceId, value){
    //TODO: Having underscore(_) in question id will break ajax functionality
	 var surveyForm = $("#"+surveyEngineFormId);
     $.ajax({
           type: 'POST',
           url: surveyForm.attr("action")+'&_eventId=ajaxRequest',
           data: surveyForm.serialize()+"&ajaxSource=true&sourceValue="+value+"&targetId="+targetId+"&sourceId="+sourceId+"&command="+cmd,
           dataType: 'html',
           success: function(data) {
               if(cmd == 'AddCopy'){
                   addCopy(data, sourceId, targetId);
                   applyRules();
               }
               else if(cmd == 'RemoveCopy') {
                   var target= targetId+"-fieldSet";
                   target = target.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" );
                   $("#"+target).remove();
                   applyRules();
               }
               else if(cmd == 'LoadCopies') {
                   addCopy(data, sourceId, targetId);
                   applyRules();
               }
               else if(cmd == 'RemoveAllCopy'){
                     var target = targetId+'-ajax';
                     $("#"+target).html('');
                     applyRules();
               }
               else if(cmd == 'GetTarget'){
                   var target = targetId+'-ajax';
                   $("#"+target).html(data);
                   applyRules();
               }
               else {
                 alert('Command not found: '+cmd);
               }
           },
           statusCode: {
             404: function() {
               alert('page not found');
             }
           }
         });
 }

function applyValidation(formId){
    $(formId).validate({
        normalizer: function(value) {
            return $.trim(value);
        },
        onkeyup: false,
        ignore: ':hidden',
        errorPlacement: handleErrorPlacement,
        invalidHandler: function(form, validator) {
            if(!showErrors){
                //don't show error and remove field markers
                return;
            }
            var errors = validator.numberOfInvalids();
            if (errors) {
                var message = errors == 1
                        ? getMessage('error.missed_field','You missed 1 field. It has been indicated below.')
                        : getMessage('error.missed_fields','You missed ' + errors + ' fields.  They have been indicated below.', [errors]);
                $("#messaging").html('<div class="alert alert-warning alert-dismissible fade show" role="alert"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button><p>' + message + '</div>' );
                $("#messaging").addClass('oldvdError');
                $(window).scrollTop();//scroll to top if this is a long page
            } else {
                $("#messaging").removeClass('oldvdError');
            }
        },
        highlight: function(element, errorClass, validClass) {
            if(!showErrors){
                //don't show field markers
                return;
            }
            if (element.type === 'radio') {
                this.findByName(element.name).addClass(errorClass).removeClass(validClass);
            } else {
                $(element).addClass(errorClass).removeClass(validClass);
                mimicMaterialFloatingLabel(element);
            }
        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
            mimicMaterialFloatingLabel(element);
            updateFormOutlineLayout($(element).closest('.form-outline'));
        },
        submitHandler: function(form) {
            var eventId = $("input[name='_eventId']", form).val();
        	$("#isEngineDone").val("true");
        	resetFieldsInHiddenContainers(form.id);//clear hidden fields
        	// Remove commas from address fields before form submission
        	$('.line1').each(function() {
                $(this).val($(this).val().replace(/,/g, ''));
        	});
        	$('.line2').each(function() {
                $(this).val($(this).val().replace(/,/g, ''));
        	});
			if($('.validateAddress').length > 0){
				if(eventId != 'saveForLater' && eventId != 'previous'){
					var val = performAddressValidation();
					if(val === "error" || val === "update"){
						enableQuestionnaireNavigation();
						return false;
					}
				}
			}
			// Bootstrap 5 vanilla JS: Set button to loading state
			const continueBtn = document.getElementById('continue');
			if (continueBtn) {
				continueBtn.disabled = true;
				const originalText = continueBtn.innerHTML;
				continueBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Loading...';
				continueBtn.setAttribute('data-original-text', originalText);
			}
            form.submit();
        }
    });
}

function enableQuestionnaireNavigation(){
	$('#pnContinueSpinner').hide();
	$('#pnContinue').show();
	$('#pnContinue').removeAttr("disabled");

	$('#pnPreviousSpinner').hide();
	$('#pnPrevious').show();
	$('#pnPrevious').removeAttr("disabled");
}

function findZipCodeFromQuestionnaire(zipFieldId, countyFieldId, stateFieldId, fipsFieldId) {
    var $county = $('#'+countyFieldId);
    var $state = $('#'+stateFieldId);
    var fips = $('#'+fipsFieldId);
    var url = getContextPath()+"/eapp/zipcode?zip=" + $('#'+zipFieldId).val();

	$.getJSON(url, function(data) {
	    $county.empty();
		$.each(data, function(i, val) {
			if (i == 0) {
				$county.append($('<option>').text('--Please Select--').attr('value', ''));
			}
			$county.append($('<option>').text(val.county).attr({value: val.county, state: val.stateAbbreviation, fips: val.fipsCode}));
			if ($state !== 'undefined') {
				$state.val(val.stateAbbreviation).change();
			}
			if (fips !== 'undefined') {
				fips.val(val.fipsCode);
			}
		});

		var $countyParent = $county.parent().closest('div[id^="'+countyFieldId+'"]');
		if(data.length > 1){
		    //hide county parent.
			$countyParent.show();
			$county.focus();
		}
		if(data.length == 1){
            $county.val(data[0].county);
        }
	});
}

function addResponderNameToContent(){
	//when we have a OIText element we just want to replace the name field
	$("oitext.FNLNS").each(function() {
	    var rId = $(this).attr('data-responder-id');
	    if(rId){
            var responderName = findResponderName(rId,false);
            $(this).html(responderName);
        }
	});
	$("oitext.FN").each(function() {
	    var rId =$(this).attr('data-responder-id');
	    if(rId){
            var responderName = findResponderName(rId,true);
            $(this).html(responderName);
        }
	});


	$("label:contains('[FNLNS]'),p:contains('[FNLNS]'),span:contains('[FNLNS]'),div:contains('[FNLNS]'),h2:contains('[FNLNS]'),option:contains('[FNLNS]')").each(function() {
	    var rId = $(this).attr('data-responder-id');
	    if(rId === undefined){
	        rId = $(this).parent().attr('data-responder-id');
	    }
	    if(rId){
            var responderName = findResponderName(rId,false);
            while ($(this).html().indexOf('[FNLNS]') !== -1) {
				var content = $(this).html().replace('[FNLNS]',"<oitext data-responder-id='"+rId+"' class='FNLNS'>"+responderName+"</oitext>");
				$(this).html(replaceSurveyPlaceHolderStaticContent(content));
            }
        }
	});
	$("label:contains('[FN]'),p:contains('[FN]'),span:contains('[FN]'),div:contains('[FN]'),h2:contains('[FN]'),option:contains('[FN]')").each(function() {
	    var rId = $(this).attr('data-responder-id');
	    if(rId === undefined){
	        rId = $(this).parent().attr('data-responder-id');
	    }
	    if(rId){
            var responderName = findResponderName(rId,true);
            var content = $(this).html().replace('[FN]',"<oitext data-responder-id='"+rId+"' class='FN'>"+responderName+"</oitext>");
            $(this).html(replaceSurveyPlaceHolderStaticContent(content));
        }
	});
}


function findResponderName(rId,firstNameOnly) {
    var match = $('#responder-full-name option').filter(function() {
       return ($(this).val() === rId);
    });
    if (match.length === 0) {
        return "";
    }
    return firstNameOnly ? match.attr('label') : match.attr('label')+" "+match.html();
}

function replaceSurveyPlaceHolderContent(rId,originalContent){
    var responderFirstName = findResponderName(rId,true);
    var responderFullName = findResponderName(rId,false);
    var today = new Date();
    var SixtyDaysAfter = new Date();
    SixtyDaysAfter.setDate(SixtyDaysAfter.getDate() + 60);
    var SixtyDaysBefore = new Date();
    SixtyDaysBefore.setDate(SixtyDaysBefore.getDate() - 60);

    originalContent = originalContent.replace(/\[FN\]/g, responderFirstName);
    originalContent = originalContent.replace(/\[FNLNS\]/g, responderFullName);
    originalContent = originalContent.replace(/\[Today\]/g, today.toLocaleDateString("en-US"));
	originalContent = originalContent.replace(/\[SixtyDaysAfter\]/g, SixtyDaysAfter.toLocaleDateString("en-US"));
	originalContent = originalContent.replace(/\[SixtyDaysBefore\]/g, SixtyDaysBefore.toLocaleDateString("en-US"));

    return replaceSurveyPlaceHolderStaticContent(originalContent);
}

function replaceSurveyPlaceHolderStaticContent(originalContent){
    $( ".static-placeholder option" ).each( function( index, element ) {
       originalContent = originalContent.replace(element.value,element.textContent);
    });
    return originalContent;
}


function updateResponderDataList(){
    $( ".responderName" ).change(function() {
       var rId =  $(this).attr('data-responder-id');
       var val = $(this).val();
       var match = $('#responder-full-name option').filter(function() {
           return ($(this).val() === rId);
       });
       if(match){
            match.attr('label',val);
            addResponderNameToContent();
       }
    });
    $( ".responderLastName" ).change(function() {
       var rId =  $(this).attr('data-responder-id');
       var val = $(this).val();
       var match = $('#responder-full-name option').filter(function() {
           return ($(this).val() === rId);
       });
       if(match){
            match.html(val);
            addResponderNameToContent();
       }
    });
}
